import axios from 'axios';
import config from "../config/app";
import * as session from "./session";

export function call(onFulfilled) {
    return getClient(config.api.base).then(onFulfilled);
}

export const getClient = (baseURL) => {
    const instance = axios.create();

    instance.defaults.baseURL = baseURL;
    return session
        .refresh()
        .then(result => {
            const tokens = JSON.parse(sessionStorage.getItem("tokens"));
            instance.defaults.headers.common["Authorization"] = tokens.idToken.jwtToken;

            return instance
        });
};


// WEBPACK FOOTER //
// ./src/api/api.js